import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const ForeignUniversityFilter = ({ label = "l.searchFilter.university", ...others }: FilterLabelProps) => {
  return (
    <>
      <BaseInputFieldFilter sm={6} md={3} fieldName={"university"} label={label} {...others} />
    </>
  );
};

export default ForeignUniversityFilter;
